import { connect } from 'react-redux';
import CrossPageActionTracker from './CrossPageActionTracker';
import { trackPreviousMonolithAction } from '../destinationPageActions';

const mapDispatchToProps = {
    trackPreviousMonolithAction,
};

export default connect(null, mapDispatchToProps)(CrossPageActionTracker);
